var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { PeekBox, theme } from "@piiqtechnologies/ui-components";
import { WebEditor, useRefetch } from "@piiqtechnologies/ui-lib";
import { useAuthContext } from "@stores/AuthContext";
export const SpaceWebEditor = (_a) => {
    var { id, onLoad, containerHeight } = _a, props = __rest(_a, ["id", "onLoad", "containerHeight"]);
    const { refetch } = useRefetch();
    const { proxyUser } = useAuthContext();
    return (React.createElement(PeekBox, { sx: {
            "> .MuiBox-root": {
                borderRadius: theme.spacing(0.8),
                boxShadow: `0px ${theme.spacing(0.2)} ${theme.spacing(0.5)} ${theme.palette.grey[200]}, 0px 0px ${theme.spacing(2)} ${theme.palette.grey[200]}`,
                height: containerHeight || 420,
                position: "relative",
            },
        } },
        React.createElement(WebEditor, Object.assign({ enableVirtualStaging: !!proxyUser, id: id, onLoad: onLoad, refetch: refetch }, props))));
};
export default SpaceWebEditor;
